import { useNavigate, useLocation } from "react-router-dom";
import { Home, Plus, ArrowLeft } from "lucide-react";

const navItems = [
  { path: "/", icon: Home },
  { path: "/meetings/new", icon: Plus },
  { path: "back", icon: ArrowLeft }, // keyword, not a route
];

function MobileNav({ className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") return /^\/[^/]*$/.test(location.pathname);
    return location.pathname === path;
    };

  return (
    <nav className={`w-full pointer-events-none ${className}`}>
      <div
        className="
          pointer-events-auto flex justify-around items-center h-20 rounded-t-3xl
          backdrop-blur-xl dark:bg-black/40 bg-gray-100
          pb-6 pt-2 shadow-[0_-4px_20px_rgba(0,0,0,0.3)] border-t border-white/20
        "
      >
        {navItems.map(({ path, icon: Icon }) => (
          <button
            key={path}
            type="button"
            onClick={() => (path === "back" ? navigate(-1) : navigate(path))}
            className={`flex flex-col items-center transition-colors ${
              isActive(path) ? "text-primary" : "text-gray-700 dark:text-gray-300"
            } hover:text-primary`}
            aria-label={path === "back" ? "Go back" : `Go to ${path}`}
          >
            <Icon size={28} strokeWidth={2.5} />
          </button>
        ))}
      </div>
    </nav>
  );
}

export default MobileNav;